/**
 * Phone display normalisation for Kaiso chatbot UI.
 *
 * Raw phones stored in MongoDB come from WhatsApp JIDs stripped of @s.whatsapp.net,
 * but the number itself can be malformed (e.g. prefix prepended twice → 15+ digits).
 * Never show a raw malformed number; fall back to "Número indisponível".
 *
 * Rules for valid display:
 *  - Strip any leading '+' or spaces
 *  - Length 7–15 digits (E.164 upper bound)
 *  - ES tenant: 34 + 9 digits starting with 6 or 7 (12 digits total)
 *
 * Logs PHONE_UI_FALLBACK_USED when the number is invalid.
 */

const MAX_E164_DIGITS = 15;
const MIN_DIGITS = 7;

function digitsOnly(raw) {
  return (raw || "").replace(/\D/g, "");
}

function isValidLength(digits) {
  return digits.length >= MIN_DIGITS && digits.length <= MAX_E164_DIGITS;
}

/**
 * Returns a display string like "+34612345678" or "Número indisponível".
 *
 * @param {string|null|undefined} rawPhone  — raw phone from contact object
 * @param {string} [context]                — optional tag for logs (e.g. "ContactItem")
 * @returns {string}
 */
export function formatPhoneForDisplay(rawPhone, context = "phone") {
  const digits = digitsOnly(rawPhone);

  if (!digits || !isValidLength(digits)) {
    if (rawPhone) {
      // eslint-disable-next-line no-console
      console.warn(
        `[PHONE_UI_FALLBACK_USED] context=${context} raw="${rawPhone}" digits="${digits}" reason=${
          !digits ? "empty" : digits.length > MAX_E164_DIGITS ? "too_long" : "too_short"
        }`
      );
    }
    return "Número indisponível";
  }

  return `+${digits}`;
}

/**
 * Returns just the digits for href:tel links, or null if invalid.
 */
export function phoneForHref(rawPhone) {
  const digits = digitsOnly(rawPhone);
  return isValidLength(digits) ? digits : null;
}
